/** Strings of the suggestion queues, time-proposal table and saved-analysis page: `analysisQueueEn` is the source, `analysisQueueCs` must have the same keys. */
export const analysisQueueEn = {
  analysisQueue: {
    picker: {
      label: "Target ticket:",
      placeholder: "Search a ticket to attach the comment to…",
      noneSelected: "— none selected —",
      noWorkItem: "no work item",
      searching: "Searching…",
      noMatches: "No matches.",
    },
    source: {
      label: "Source:",
      type: {
        meeting: "Meeting",
        whatsapp: "WhatsApp",
        email: "Email",
        discord: "Discord",
        duplicate_scan: "Duplicate scan",
        idle_proposal: "Agent's proposal while idle",
      },
      viewAnalysis: "view analysis",
      openChat: "open chat",
      openChannel: "open channel",
    },
    queue: {
      tab: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        all: "All",
      },
      applied: "Applied",
      loadFailed: "Couldn't load suggestions.",
      rejectFailed: "Couldn't reject this suggestion.",
      pageEmpty: "This page is empty — the queue is shorter than it was.",
      emptyPending:
        "Nothing waiting — new suggestions from emails, WhatsApp, and transcript analyses land here.",
      empty: "Nothing here.",
    },
    timeQueue: {
      tab: {
        pending: "Waiting",
        approved: "Logged",
        rejected: "Rejected",
        all: "All",
      },
      loadFailed: "Couldn't load proposed time entries.",
      saveFailed: "Couldn't save that change.",
      noMatch: "Nothing matches these filters.",
      emptyMine:
        "Nothing waiting — proposals from your time tracker and from meetings you attended land here.",
      emptyAll: "Nothing waiting — nobody on the team has proposed time to confirm.",
    },
    timeFilters: {
      byProject: "Filter by project",
      allProjects: "All projects",
      noProject: "— no project yet —",
      byPerson: "Filter by person",
      everyone: "Everyone",
      nobody: "— nobody assigned —",
      byRange: "Filter by date range",
      allTime: "All time",
      preset: {
        today: "Today",
        "this-week": "This week",
        "last-week": "Last week",
        "this-month": "This month",
      },
      custom: "Custom range",
      from: "From",
      to: "To",
      fromDate: "Filter from date",
      toDate: "Filter to date",
      clear: "Clear",
    },
    timeTable: {
      person: "Person",
      nobody: "nobody assigned",
      date: "Date",
      length: "Length",
      project: "Project",
      workItem: "Work item",
      description: "Description",
      whereFrom: "Where it came from",
      decision: "Decision",
      durationMinutes: "Duration in minutes",
      min: "min",
      projectOption: "— project —",
      gitlabId: "GitLab id {{id}}",
      pairProject: "Pair project",
      communicationHint:
        "Meeting time is filed as Communication overhead and isn't bound to a work item.",
      communication: "Communication",
      proposedHint:
        'The tracker found no ticket for this work and suggests filing one called "{{title}}".',
      ticketOnApprove: "Approving files it as done",
      overheadHint:
        "The tracker judged this to be project overhead — communication, deployment, infrastructure — rather than work on a ticket. Approving it as it stands files it under the project's overhead.",
      overhead: "Overhead",
      rejected: "Rejected",
      open: "open",
      tomorrow: "Tomorrow",
      tomorrowHint:
        "Time is confirmed a day later. Today's is still being tracked — the length can still grow while you're working.",
      logThis: "Log this time",
      reject: "Reject",
      logging: "Logging…",
      rejecting: "Rejecting…",
      origin: {
        analysis: "AI analysis",
        api: "Time tracker",
        manual: "Entered by hand",
      },
      spokeAs: "Spoke as “{{name}}”",
      repositoryWithId: "Repository {{repo}} (GitLab id {{id}})",
      repository: "Repository {{repo}}",
      checkout: "Checkout {{path}}",
      rejectedReason: "Rejected: {{reason}}",
      whereFromSource: "Where this came from: {{source}}",
      viewAnalysis: "view analysis",
    },
    card: {
      include: "Include suggestion",
      action: {
        create_work_item: "New item",
        add_comment: "Comment",
        change_priority: "Priority",
        augment_description: "Spec",
        revise_description: "Spec change",
        set_fixed_price: "Fixed price",
        change_estimate: "Estimate",
        change_status: "Status",
        change_assignee: "Assignee",
        merge_duplicate: "Duplicate",
      },
      applying: "Applying…",
      rejecting: "Rejecting…",
      rejected: "Rejected",
      open: "open",
      kind: "Kind",
      kinds: {
        feature: "Work item",
        bug: "Bug",
        task: "Task (no code)",
        hotfix: "Hotfix",
        idea: "Idea",
      },
      project: "Project",
      none: "— none —",
      pickProject: "— pick a project —",
      priority: {
        label: "Priority",
        low: "low",
        normal: "normal",
        high: "high",
        urgent: "urgent",
      },
      assignee: "Assignee",
      pickProjectFirst: "— pick a project first —",
      loading: "Loading…",
      projectManager: "— the project's manager —",
      status: "Status",
      stateNew: "New (default)",
      stateEstimation: "Estimation",
      needsAssignee: "(needs an assignee)",
      titlePlaceholder: "Title",
      descriptionPlaceholder: "Description",
      commentInstead: "Comment instead",
      commentPlaceholder: "Comment",
      newPriority: "New priority",
      augmentPlaceholder: "New detail to append to the spec (the existing description is kept)",
      separateItem: "Create separate work item instead",
      fixedPrice: "Fixed price (Kč)",
      estimateHours: "Estimate (hours)",
      workItem: "Work item:",
      currently: "currently {{value}}",
      moveTo: "Move to",
      handOverTo: "Hand over to",
      keep: "Keep",
      duplicate: "Duplicate",
      mergeHint:
        "Apply to merge the duplicate(s) into the kept item — their description and comments move over, then each duplicate is closed as a duplicate.",
      why: "Why:",
      rejectPlaceholder: "Why is this wrong? (optional — helps Hubert learn)",
      confirmReject: "Confirm reject",
      cancel: "Cancel",
      merge: "Merge",
      apply: "Apply",
      reject: "Reject",
      redraftFailed: "Couldn't write it again.",
      revisedSpec: "Revised specification",
      showChanges: "Show changes",
      editText: "Edit text",
      redrafting: "Writing again…",
      redraft: "Write again against the current spec",
      state: {
        spec_drafting: "creating specification",
        spec_client_review: "specification approval",
        internal_test_dev: "internal testing on dev",
        client_test_dev: "client testing on dev",
        internal_test_test: "internal testing on test",
        client_test_test: "client testing on test",
        internal_test_main: "internal testing on production",
        client_test_main: "client testing on production",
      },
    },
    history: {
      loadFailed: "Couldn't load this analysis.",
      deleted: "Analysis deleted",
      deleteFailed: "Couldn't delete the analysis.",
      back: "Back",
      loading: "Loading…",
      title: "Saved analysis",
      from: "From a {{source}}",
      source: {
        meeting: "meeting transcript",
        whatsapp: "WhatsApp chat",
        email: "client email",
      },
      project: "Project",
      projectSaved: "Saved. “Analyse again” now uses this project.",
      delete: "Delete",
      deleteTitle: "Delete this analysis?",
      deleteBody_one:
        "Deletes the analysis and its {{count}} proposal (any already-applied work items / comments / time entries stay). This can't be undone.",
      deleteBody_few:
        "Deletes the analysis and its {{count}} proposals (any already-applied work items / comments / time entries stay). This can't be undone.",
      deleteBody_other:
        "Deletes the analysis and its {{count}} proposals (any already-applied work items / comments / time entries stay). This can't be undone.",
      deleting: "Deleting…",
      rerunWithNote: "Re-run with a note",
      rerun: "Re-run",
      ranAgainOf: "Ran again over the conversation of",
      earlierAnalysis: "an earlier analysis",
      keepsOwn: "That one keeps its own proposals.",
      analysedLater: "This conversation was analysed again later:",
      summary: "Summary",
      sourceConversation: "Source conversation",
      showConversation: "Show the analysed conversation",
      noSuggestions: "No work item suggestions",
      suggestions_one: "{{count}} work item suggestion",
      suggestions_few: "{{count}} work item suggestions",
      suggestions_other: "{{count}} work item suggestions",
      applySelected: "Apply selected ({{count}})",
      timeProposals_one: "{{count}} proposed time entry",
      timeProposals_few: "{{count}} proposed time entries",
      timeProposals_other: "{{count}} proposed time entries",
    },
  },
};
export const analysisQueueCs: typeof analysisQueueEn = {
  analysisQueue: {
    picker: {
      label: "Cílový tiket:",
      placeholder: "Vyhledejte tiket, ke kterému se komentář připojí…",
      noneSelected: "— nic nevybráno —",
      noWorkItem: "žádný tiket",
      searching: "Hledám…",
      noMatches: "Nic nenalezeno.",
    },
    source: {
      label: "Zdroj:",
      type: {
        meeting: "Schůzka",
        whatsapp: "WhatsApp",
        email: "E-mail",
        discord: "Discord",
        duplicate_scan: "Hledání duplicit",
        idle_proposal: "Návrh agenta z volné chvíle",
      },
      viewAnalysis: "zobrazit analýzu",
      openChat: "otevřít chat",
      openChannel: "otevřít kanál",
    },
    queue: {
      tab: {
        pending: "Čekající",
        approved: "Schválené",
        rejected: "Zamítnuté",
        all: "Vše",
      },
      applied: "Použito",
      loadFailed: "Návrhy se nepodařilo načíst.",
      rejectFailed: "Návrh se nepodařilo zamítnout.",
      pageEmpty: "Tato stránka je prázdná — fronta je kratší než dřív.",
      emptyPending:
        "Nic nečeká — nové návrhy z e-mailů, WhatsAppu a analýz přepisů se objeví tady.",
      empty: "Nic tu není.",
    },
    timeQueue: {
      tab: {
        pending: "Čekající",
        approved: "Zapsané",
        rejected: "Zamítnuté",
        all: "Vše",
      },
      loadFailed: "Navržené časové záznamy se nepodařilo načíst.",
      saveFailed: "Změnu se nepodařilo uložit.",
      noMatch: "Těmto filtrům nic neodpovídá.",
      emptyMine:
        "Nic nečeká — návrhy z vašeho trackeru času a ze schůzek, kterých jste se zúčastnili, se objeví tady.",
      emptyAll: "Nic nečeká — nikdo z týmu nenavrhl čas k potvrzení.",
    },
    timeFilters: {
      byProject: "Filtrovat podle projektu",
      allProjects: "Všechny projekty",
      noProject: "— zatím bez projektu —",
      byPerson: "Filtrovat podle osoby",
      everyone: "Všichni",
      nobody: "— nikdo nepřiřazen —",
      byRange: "Filtrovat podle období",
      allTime: "Celé období",
      preset: {
        today: "Dnes",
        "this-week": "Tento týden",
        "last-week": "Minulý týden",
        "this-month": "Tento měsíc",
      },
      custom: "Vlastní rozsah",
      from: "Od",
      to: "Do",
      fromDate: "Filtrovat od data",
      toDate: "Filtrovat do data",
      clear: "Zrušit filtry",
    },
    timeTable: {
      person: "Osoba",
      nobody: "nikdo nepřiřazen",
      date: "Datum",
      length: "Délka",
      project: "Projekt",
      workItem: "Tiket",
      description: "Popis",
      whereFrom: "Odkud to pochází",
      decision: "Rozhodnutí",
      durationMinutes: "Délka v minutách",
      min: "min",
      projectOption: "— projekt —",
      gitlabId: "GitLab id {{id}}",
      pairProject: "Spárovat projekt",
      communicationHint: "Čas na schůzkách se zapisuje jako režie komunikace a neváže se na tiket.",
      communication: "Komunikace",
      proposedHint:
        "Tracker k této práci nenašel žádný tiket a navrhuje založit nový s názvem „{{title}}“.",
      ticketOnApprove: "Schválením se založí jako hotový",
      overheadHint:
        "Tracker usoudil, že jde o režii projektu — komunikaci, nasazení, infrastrukturu — a ne o práci na tiketu. Schválením v tomto stavu se zapíše do režie projektu.",
      overhead: "Režie",
      rejected: "Zamítnuto",
      open: "otevřít",
      tomorrow: "Zítra",
      tomorrowHint:
        "Čas se potvrzuje o den později. Dnešní se ještě zaznamenává — délka může při práci dál růst.",
      logThis: "Zapsat tento čas",
      reject: "Zamítnout",
      logging: "Zapisuji…",
      rejecting: "Zamítám…",
      origin: {
        analysis: "AI analýza",
        api: "Tracker času",
        manual: "Zadáno ručně",
      },
      spokeAs: "Mluvil(a) jako „{{name}}“",
      repositoryWithId: "Repozitář {{repo}} (GitLab id {{id}})",
      repository: "Repozitář {{repo}}",
      checkout: "Pracovní kopie {{path}}",
      rejectedReason: "Zamítnuto: {{reason}}",
      whereFromSource: "Odkud to pochází: {{source}}",
      viewAnalysis: "zobrazit analýzu",
    },
    card: {
      include: "Zahrnout návrh",
      action: {
        create_work_item: "Nový tiket",
        add_comment: "Komentář",
        change_priority: "Priorita",
        augment_description: "Specifikace",
        revise_description: "Změna specifikace",
        set_fixed_price: "Pevná cena",
        change_estimate: "Odhad",
        change_status: "Stav",
        change_assignee: "Řešitel",
        merge_duplicate: "Duplicita",
      },
      applying: "Používám…",
      rejecting: "Zamítám…",
      rejected: "Zamítnuto",
      open: "otevřít",
      kind: "Druh",
      kinds: {
        feature: "Tiket",
        bug: "Chyba",
        task: "Úkol (bez kódu)",
        hotfix: "Hotfix",
        idea: "Nápad",
      },
      project: "Projekt",
      none: "— žádný —",
      pickProject: "— vyberte projekt —",
      priority: {
        label: "Priorita",
        low: "nízká",
        normal: "běžná",
        high: "vysoká",
        urgent: "urgentní",
      },
      assignee: "Řešitel",
      pickProjectFirst: "— nejdřív vyberte projekt —",
      loading: "Načítám…",
      projectManager: "— manažer projektu —",
      status: "Stav",
      stateNew: "Nový (výchozí)",
      stateEstimation: "Odhad",
      needsAssignee: "(vyžaduje řešitele)",
      titlePlaceholder: "Název",
      descriptionPlaceholder: "Popis",
      commentInstead: "Raději komentář",
      commentPlaceholder: "Komentář",
      newPriority: "Nová priorita",
      augmentPlaceholder: "Nový detail k doplnění specifikace (stávající popis zůstane)",
      separateItem: "Raději založit samostatný tiket",
      fixedPrice: "Pevná cena (Kč)",
      estimateHours: "Odhad (hodiny)",
      workItem: "Tiket:",
      currently: "nyní {{value}}",
      moveTo: "Přesunout do stavu",
      handOverTo: "Předat komu",
      keep: "Ponechat",
      duplicate: "Duplicita",
      mergeHint:
        "Použitím se duplicity sloučí do ponechaného tiketu — jejich popis a komentáře se přenesou a každá duplicita se uzavře jako duplicitní.",
      why: "Proč:",
      rejectPlaceholder: "Proč je to špatně? (nepovinné — pomáhá Hubertovi se učit)",
      confirmReject: "Potvrdit zamítnutí",
      cancel: "Zrušit",
      merge: "Sloučit",
      apply: "Použít",
      reject: "Zamítnout",
      redraftFailed: "Přepsání se nepodařilo.",
      revisedSpec: "Upravená specifikace",
      showChanges: "Zobrazit změny",
      editText: "Upravit text",
      redrafting: "Přepisuji…",
      redraft: "Přepsat znovu podle aktuální specifikace",
      state: {
        spec_drafting: "vytváření specifikace",
        spec_client_review: "schválení specifikace",
        internal_test_dev: "interní testování na dev",
        client_test_dev: "klientské testování na dev",
        internal_test_test: "interní testování na testu",
        client_test_test: "klientské testování na testu",
        internal_test_main: "interní testování na produkci",
        client_test_main: "klientské testování na produkci",
      },
    },
    history: {
      loadFailed: "Tuto analýzu se nepodařilo načíst.",
      deleted: "Analýza smazána",
      deleteFailed: "Analýzu se nepodařilo smazat.",
      back: "Zpět",
      loading: "Načítám…",
      title: "Uložená analýza",
      from: "Z {{source}}",
      source: {
        meeting: "přepisu schůzky",
        whatsapp: "chatu na WhatsAppu",
        email: "e-mailu klienta",
      },
      project: "Projekt",
      projectSaved: "Uloženo. „Analyzovat znovu“ teď použije tento projekt.",
      delete: "Smazat",
      deleteTitle: "Smazat tuto analýzu?",
      deleteBody_one:
        "Smaže analýzu a její {{count}} návrh (již použité tikety, komentáře a časové záznamy zůstanou). Nelze vrátit zpět.",
      deleteBody_few:
        "Smaže analýzu a její {{count}} návrhy (již použité tikety, komentáře a časové záznamy zůstanou). Nelze vrátit zpět.",
      deleteBody_other:
        "Smaže analýzu a jejích {{count}} návrhů (již použité tikety, komentáře a časové záznamy zůstanou). Nelze vrátit zpět.",
      deleting: "Mažu…",
      rerunWithNote: "Opakované spuštění s poznámkou",
      rerun: "Opakované spuštění",
      ranAgainOf: "Znovu spuštěno nad konverzací z",
      earlierAnalysis: "dřívější analýzy",
      keepsOwn: "Ta si ponechává své vlastní návrhy.",
      analysedLater: "Tato konverzace byla později analyzována znovu:",
      summary: "Souhrn",
      sourceConversation: "Zdrojová konverzace",
      showConversation: "Zobrazit analyzovanou konverzaci",
      noSuggestions: "Žádné návrhy tiketů",
      suggestions_one: "{{count}} návrh tiketu",
      suggestions_few: "{{count}} návrhy tiketů",
      suggestions_other: "{{count}} návrhů tiketů",
      applySelected: "Použít vybrané ({{count}})",
      timeProposals_one: "{{count}} navržený časový záznam",
      timeProposals_few: "{{count}} navržené časové záznamy",
      timeProposals_other: "{{count}} navržených časových záznamů",
    },
  },
};
